import { useState, useEffect } from 'react';
import { getSuppliers } from '../services/suppliers';
import type { Database } from '../types/supabase';

type Supplier = Database['public']['Tables']['suppliers']['Row'];

export function useSuppliers() {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        setIsLoading(true);
        const data = await getSuppliers();
        setSuppliers(data);
      } catch (err) {
        console.error('Error fetching suppliers:', err);
        setError(err instanceof Error ? err : new Error('Failed to fetch suppliers'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchSuppliers();
  }, []);

  return { suppliers, isLoading, error };
}